<mat-card id="custodia-cliente-rv"> 
    <mat-card-header style="margin-bottom: 20px">
        <mat-card-title>Painel RV</mat-card-title>
        <button 
            mat-mini-fab                                        
            *ngIf="this.user.role_id == 2 || this.user.role_id == 7 || this.user.tipo_usuario_id == 2"
            matTooltip="Adicionar nova Custódia"
            (click)="openAddAtivo()"
        >
            <mat-icon>add</mat-icon>
        </button>
        <br/>
        <br/>      
        
        <div class="valor-investido">
            <div>
                <span>
                    <span>Total Investido Inicial: </span>  <br/>
                    <span>
                        <b>R$ {{ total_financeiro_inicial | number : '1.2-2' }}</b>
                    </span>
                </span> 
            </div>
            <div>
                <span>
                    <span>Total Financeiro Hoje: </span> <br/>
                    <span>
                        <b>R$ {{ total_financeiro_atual | number : '1.2-2' }}</b>
                    </span> 
                </span> 
            </div>
            <div>
                <span>
                    <span>Variação Pecentual:</span>  <br/>
                    <span
                        [ngClass]="{
                        'negativo': variacao_percentual < 0, 
                        'positivo': variacao_percentual > 0
                        }"
                    >
                        <b>{{ variacao_percentual | number : '1.2-2' }} %</b>
                    </span>
                </span>
            </div>
        </div>

    </mat-card-header>

    <mat-card-content>

        <div id="about" class="p-24" fxLayout="row wrap">            
            <mat-accordion>
                <mat-expansion-panel *ngFor="let estrategia of listEstrategia">
                    <mat-expansion-panel-header>                                  
                        <mat-panel-title class="titulo-painel-custodia">                
                            <div style="float: left;">
                                <span>{{ estrategia.nome.toLocaleUpperCase() }}</span> <br />
                                <span style="font-size: 14px;">
                                    Alocação: {{ getAlocacao(estrategia) | number : '1.2-2' }} %
                                </span>
                            </div>
                            <div 
                                class="cor_estrategia" 
                                [ngClass]="estrategia.cor_hexadecimal">
                            </div>
                        </mat-panel-title>
                        <mat-panel-description>
                            <span class="texto-estrategia">
                                <span>Total Investido:</span><br />
                                <span><b>R$ {{ estrategia.valor_inicial_total_estrategia | number : '1.2-2'}}</b></span> 
                            </span> | 
                            <span class="texto-estrategia">
                                <span>Total Financeiro (Hoje):</span> <br/>
                                <span>
                                    <b>R$ {{ estrategia.valor_atual_total_estrategia | number : '1.2-2' }}</b>
                               </span> 
                            </span> |
                            <span class="texto-estrategia">
                                <span>Variação Percentual:</span><br/>
                                <span
                                    [ngClass]="{
                                    'negativo': getPercentual(estrategia) < 0 , 
                                    'positivo': getPercentual(estrategia) > 0
                                    }"
                                >
                                    <b>{{ getPercentual(estrategia) | number : '1.2-2' }} %</b> 
                                </span>
                            </span>             
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    
                    <ng-template matExpansionPanelContent>
                        <lista-custodia-rv-cliente 
                            [cliente_id]="cliente_id"
                            [estrategia_id]="estrategia.id"
                            (refreshEvent)="refreshItem($event)"
                        >
                        </lista-custodia-rv-cliente>
                    </ng-template>
                </mat-expansion-panel>

                <lista-custodia-derivativos 
                    [cliente_id]="cliente_id"                    
                >
                </lista-custodia-derivativos>

                <lista-custodia-proventos 
                    [cliente_id]="cliente_id"   
                    (totalProventosEvent)="refreshValue($event)"                 
                >
                </lista-custodia-proventos>


            </mat-accordion>
        </div>
    </mat-card-content>
</mat-card>